export const getFlaggedName = (match) => match?.primaryName || match?.matchedName || '—';

export const formatMatchScore = (score) => {
  if (score == null || score === '') return '—';
  const numeric = Number(score);
  if (Number.isNaN(numeric)) return String(score);
  return `${numeric}%`;
};

export const getMatchScore = (match) => match?.score ?? match?.matchScore ?? null;

export const getPrimaryDataset = (data, match) => {
  if (Array.isArray(match?.datasets) && match.datasets.length > 0) {
    return match.datasets[0];
  }
  if (Array.isArray(data?.matchedDatasets) && data.matchedDatasets.length > 0) {
    return data.matchedDatasets[0];
  }
  return null;
};

export const isPepMatch = (match) => {
  const value = match?.isPEP ?? match?.isPep;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'yes' || value.toLowerCase() === 'true';
  return false;
};
